import {WinPresentationController} from "../WinPresentationController";
import {TimelineLite} from "gsap";
import {WalkOfShame} from "../../WalkOfShame";

export class BreakBankController extends WinPresentationController {

    constructor() {
        super("BreakBankController", false);
    }

    protected hasWin(): boolean {
        return WalkOfShame.model.parsedGameData.brokeTheBank;
    }

    protected async createWinAnimation(): Promise<any> {
        const tl: TimelineLite = new TimelineLite();
        let delay: number = 0.1;

        if (WalkOfShame.model.parsedGameData.singleWin > 0) {
            delay += 0.3;
        }
        tl.to(this, {duration: delay});
        await tl;
        await new Promise<void>((resolve: () => void) => {
            WalkOfShame.keypadPlugin.setZeroBetSpinCounter(-1);
            WalkOfShame.winCapScreen.show(() => {
                resolve();
            });
        });
    }
}